import { ComboBox } from '@panwds/react-ui';
import { classNames } from '@panwds/tailwindcss';
import React, {} from 'react';
import { useFilters } from '../../hooks/index.js';
import { Pill } from '../Pill/index.js';
export function ComboBoxFilter({ name, required = false, static: isStatic, onClose, onClear, dataMetrics = 'combo-box-filter', dataTestId, label = '', className, id = 'combo-box-filter', ...rest }) {
    const { setFilters, filters } = useFilters();
    const onChange = (changes) => {
        setFilters({ [name]: changes?.inputValue });
    };
    const onFilterCloseAndOptionsClear = (e) => {
        onClose?.(e);
        onClear?.();
    };
    return (React.createElement("div", { id: id },
        React.createElement(Pill, { label: label, required: required, static: isStatic, onClose: onFilterCloseAndOptionsClear, select: React.createElement(ComboBox, { ...rest, className: {
                    ...className,
                    input: classNames('twds-border-none twds-h-full', className?.input),
                    list: classNames('twds-ml-2 twds-mt-2', className?.list)
                }, showSuffixIcon: false, value: filters[name] ?? '', onChange: onChange, dataMetrics: dataMetrics || name, dataTestId: dataTestId || name }) })));
}
//# sourceMappingURL=ComboBoxFilter.js.map